module.exports = __webpack_public_path__ + "a2bb46081da0fcb7fc0fb51f6918fafa.png";